module.exports = __webpack_public_path__ + "img/d_file.77aa266a.png";